import React from 'react';
import './style.scss';
import '../style.scss';
import logo from "assets/imgs/QrCodeMyVnptVer2/logo.png";

const Header = () => {
  return (
    <div id="qr-code__header-v2">
      <div className="qr-code__header--logo">
        <img src={logo} alt="logo" />
      </div>
    </div>
  );
}

export default React.memo(Header);
